export default __webpack_public_path__ + "static/media/project-details1.af0bc6e2.jpg";